module.exports = __webpack_public_path__ + "media/images/lesson_5/sebastiao_saltitao-828a1d3c63601690f82f46546e807733.svg";